export default __webpack_public_path__ + "static/media/Veeva_My-Engage-es.c96ab95f.mp4";